export const events = {
  incidences: {
    addNote: 'Add note',
    loadTable: 'Load table',
    sentMessage: 'Sent message',
    applyFilter: 'Apply filter',
    completeTask: 'Complete task',
    changeStatus: 'Change employee update status',
    changeStatusBulk: 'Change incidence status bulk',
    viewIncidenceDetail: 'View incidence detail',
    switchIncidenceTabDetail: 'Switch incidence tab detail',
    goToIncidencesSettings: 'Go to employee updates settings',
    requestInformationLanding: 'Click payroll incidences paywall',
    submitPayrollResults: 'Submit payroll results',
  },

  settings: {
    filterCompany: 'Filter company',
    changePersonalNotification: 'Change personal notification',
  },

  clients: {
    exportFile: 'Export file',
    changeClientNotification: 'Change client notification',
    changeIncidentValidation: 'Change incident validation',
  },
  cycles: {
    commentAddedInCompensation: 'Comment added in compensation',
    commentAddedInProfessionals: 'Comment added in professionals',
    documentsImportedInProfessionals: 'Documents imported in professionals',
    documentDeletedInProfessionals: 'Document deleted in professionals',
    payrollVariablesExportedFromProfessionals: 'Payroll variables exported from professionals',
  },
}
